export default __webpack_public_path__ + "KaTeX_Fraktur-Bold.2ea3916b4309d29ba6938ff96202f3a8.woff";